import { Injectable } from "@angular/core";
import { DateTime } from "luxon";
import { environment } from "src/environments/environment";
import * as ww from "../../assets/weeks-workouts.json";
import { DBS } from "../classes/database-manager.class";
import { LocalDb } from "../classes/local-db.class";
import { Week } from "../interfaces/week.interface";
import { Workout } from "../interfaces/workout.interface";

export enum CONST {
  WARMUP_WEEK_ID = 1,
  COOL_DOWN_WEEK_ID = 10,
  TRAINING_DAYS = 2,
  WARMUP_COOL_DOWN_COUNT = 5 + 3,
}
@Injectable({
  providedIn: 'root'
})
export class DataService {

  collections = {
    WORKOUT_DONE: 'workout_done'
  }

  dbFinishedWorkout = new LocalDb(DBS.FinishedWorkouts)
  dbWeek = new LocalDb(DBS.Weeks)

  addAudioVideoFields(data) {
    data.forEach(week => {
      week.workouts.forEach(workout => {
        workout['audio'] = workout.media.filter(media => media.type == 'audio').pop()?.name
        workout['video'] = workout.media.filter(media => media.type == 'video').pop()?.name
      })
    })
    return data
  }

  getData(): Array<Week> {
    const data = <Array<Week>>(localStorage.getItem(environment.bundle) || (ww as any).default.data)
    return this.addAudioVideoFields(data)
  }

  getWeeksOnly() {
    return this.getData().filter(item => item.week_number)
  }

  findWorkout(id: number): Workout {
    return <any>this.getData().filter(week => week.workouts.filter(workout => workout.id == id));
  }

  setData(weeks: Array<Week>) {
    localStorage.setItem(environment.bundle, JSON.stringify(weeks))
  }

  getDone(): Array<any> {
    return [
      { week_id: 1, workout_id: 1, finished_at: Date.now(), effort_perception: 6 },
      { week_id: 1, workout_id: 2, finished_at: Date.now(), effort_perception: 7 }
    ]
  }

  setDone(input) {
    localStorage.setItem(this.collections.WORKOUT_DONE, JSON.stringify(input))
  }

  setExerciseAsDone(weekId: number, workoutId: number) {
    // TODO: terminar isso aqui
    // const addWorkout = () => {
    //   this.done.
    // }
    const data = this.getData()
    data.forEach(week => {
      week.workouts.forEach(workout => {
        if (week.id == weekId && workout.id == workoutId) {
          workout.done = true;
        }
      })
    })
    this.setData(data)
  }

  async getWeekByNumber(week_number: number) {
    const weeks = await this.dbWeek.getAll()
    return weeks.filter((week: any) => week.week_number == week_number)[0]
  }

  async getWeekExercises(week_id: number) {
    const db = new LocalDb(DBS.Workouts)
    return db.query({
      field: 'week_id',
      op: '$eq',
      value: week_id,
      sort_by: 'order'
    });
  }

  async getFinishedWorkoutsOfWeek(weekId: number) {
    const finishedWorkouts = await this.dbFinishedWorkout.getAll()
    const finishedWorkoutsOfWeek = finishedWorkouts
      .filter((workout: any) => workout.week_id == weekId)
      .length
    return finishedWorkoutsOfWeek
  }

  async getExercisesNumberOnWeek(week_id: number) {
    const weekExercises = await this.getWeekExercises(week_id)
    const firstExercise = weekExercises[0]
    const repetitions = firstExercise.repetitions

    const WARMUP_LENGTH = 5
    const COOL_DOWN_LENGTH = 3
    const EXERCISE_DAY_BY_WEEK = 2

    const total = ((WARMUP_LENGTH + COOL_DOWN_LENGTH) * EXERCISE_DAY_BY_WEEK) + (weekExercises.length * repetitions * EXERCISE_DAY_BY_WEEK)

    return total
  }

  async weekCompleted(weekId: number) {
    const finishedWorkouts = await this.dbFinishedWorkout.getAll()
    const finishedWorkoutsOfWeek = finishedWorkouts
      .filter((workout: any) => workout.week_id == weekId)
      .length
    const weekExercises = await this.getWeekExercises(weekId)
    const weekExercisesTotal = (weekExercises.length * weekExercises[0].repetitions * CONST.TRAINING_DAYS)
      + (CONST.WARMUP_COOL_DOWN_COUNT * CONST.TRAINING_DAYS)
    return finishedWorkoutsOfWeek >= weekExercisesTotal
  }

  async dayCompleted(weekId: number, day: number) {
    const weekExercises = await this.getWeekExercises(weekId)
    const finishedWorkouts = await this.dbFinishedWorkout.getAll()
    const finishedWorkoutsOfDay = finishedWorkouts
      .filter((workout: any) => workout.week_id == weekId && workout.day == day)
      .length
    const weekExercisesTotal = (weekExercises.length * weekExercises[0].repetitions) + CONST.WARMUP_COOL_DOWN_COUNT
    return weekExercisesTotal <= finishedWorkoutsOfDay
  }

  async alreadyEvaluatedWeek(weekId: number) {
    const userEvaluationsDb = new LocalDb(DBS.UserEvaluations)
    const evaluations = await userEvaluationsDb.getAll()
    const weekEvaluated = evaluations
      .filter((evaluation: any) => evaluation.week_id == weekId)
      .length
    return weekEvaluated > 0
  }

  async getFinishedDays() {
    const weeks = await this.dbWeek.query({
      field: 'part',
      op: '$eq',
      value: "PRINCIPAL",
      sort_by: 'name'
    })
    const days = [1, 2]
    let completed = 0
    for (const week of weeks) {
      for (const day of days) {
        if (await this.dayCompleted(week.id, day)) {
          completed++
        }
      }
    }
    return completed
  }

  async check24HoursOrMore() {
    const finishedWorkouts = await this.dbFinishedWorkout.getAll()
    if (finishedWorkouts.length == 0) return true;
    const lastOne = <any>finishedWorkouts
      .sort((a: any, b: any) => (a.end_at > b.end_at ? -1 : 1))
      .shift()
    const now = DateTime.now();
    const endAt = DateTime.fromISO(lastOne.end_at)
    const diff = now.diff(endAt, 'hours')
    return (diff.hours >= 24) ? true : false;
  }

}
